import React from 'react';
import Carousel from "../carousel/Carousel";
import './Hero.css';

class Hero extends React.Component {
    render() {
        return (
            <div className={'hero'}>
                <table>
                    <tbody>
                    <tr className={'hero_content'}>
                        <td className={'hero_text'}>
                            <h2 className={'hero_title'}>Bespoke Joinery Built to Last</h2>
                            <p className={'hero_description'}>
                                From kitchens to custom interiors, we craft premium woodwork tailored to your home — with care, precision, and pride.
                            </p>
                            <a href="/gallery" className={'hero_button'}>View Gallery</a>
                        </td>
                        <td className={'hero_carousel'}>
                            <div className={'carousel_container'}>
                                <Carousel />
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>


            </div>
        )
    }
}

export default Hero;